<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Epigraphs</a></p>
<p class="toc"><a href="#/c01">Daphne</a></p>
<p class="toc"><a href="#/c02">An Account of Events in the Monferrato</a></p>
<p class="toc"><a href="#/c03">The Serraglio of Wonders</a></p>
<p class="toc"><a href="#/c04">Fortification Display’d</a></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">The Labyrinth of the World</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">The Great Art of Light and Shadow</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Pavane Lachryme</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">The Curious Learning of the Wits of the Day</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">The Aristotelian Telescope</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Geography and Hydrography Reformed</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The Art of Prudence</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">The Passions of the Soul</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">The Map of Tendernes</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">A Treatise on the Science of Arms</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Horologium Oscillatorium</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">Discourse on the Powder of Sympathy</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">Longitudinum Optata Scientia</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Unheard-of Curiosities</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">A New Voyage Round the World</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">Wit and the Art of Ingenuity</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">Telluris Theoria Sacra</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">The Orange Dove</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">Divers and Artificious Machines</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">Dialogues of the Maximum Systems</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">Technica Curiosa</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">Delights for the Ingenious: A Collection of Emblems</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">The Secrets of the Flux and Reflux of the Sea</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">Of the Origin of Novels</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample">The Soul of Ferrante</span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">Anatomy of Erotic Melancholy</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">A Breviary for Politicals</span></p>
<p class="toc"><span href="#/c32" title="Link target outside of Sample">A Garden of Delights</span></p>
<p class="toc"><span href="#/c33" title="Link target outside of Sample">Mundus Subterraneus</span></p>
<p class="toc"><span href="#/c34" title="Link target outside of Sample">Monologue on the Plurality of Worlds</span></p>
<p class="toc"><span href="#/c35" title="Link target outside of Sample">Joyfull Newes out of the Newfound Worlde</span></p>
<p class="toc"><span href="#/c36" title="Link target outside of Sample">The Rule and Exercises of Holy Dying</span></p>
<p class="toc"><span href="#/c37" title="Link target outside of Sample">Paradoxical Exercises Regarding the Thinking of Stones</span></p>
<p class="toc"><span href="#/c38" title="Link target outside of Sample">An Enquiry into the Nature and Place of Hell</span></p>
<p class="toc"><span href="#/c39" title="Link target outside of Sample">Itinerarium Extaticum Coeleste</span></p>
<p class="toc"><span href="#/c40" title="Link target outside of Sample">Colophon</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Translator’s Postscript</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Connect with HMH</span></p>
<p class="toc sub"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3eb640a9